import React, { useState, useRef, useEffect } from "react";
import ModalEditPhoto from "./modals/ModalEditPhoto";
import ModalCaptureContactData from "./modals/ModalCaptureContactData";
import { v4 as uuid } from "uuid";
import {
  createBackground,
  dataLookUpConst,
  getAllCards,
  getVCLookUp,
  uploadImage,
  validateDataContact,
  generateCardSocial,
  createContact,
} from "../constants";
import { QRCode } from "react-qrcode-logo";
import { useNavigate } from "react-router-dom";
import { FaCamera } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import {
  add_circle,
  trash_can,
  bottom_left,
  bottom_right,
  top_left,
  top_right,
} from "../assets";
import ContactCard from "./ContactCard";

const AddContact = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const [loading, setLoading] = useState(false);

  const inputFile = useRef(null);
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [indexCard, setIndexCard] = useState(0);
  const [showCapture, setShowCapture] = useState(false);
  const [lastName, setLastName] = useState("");
  const [cards, setCards] = useState([]);
  const [additionalPhones, setAdditionalPhones] = useState([
    {
      phone: "",
      label: "personal",
    },
  ]);
  const [additionalEmails, setAdditionalEmails] = useState([
    {
      email: "",
      label: "personal",
    },
  ]);
  const [jobTitle, setJobTitle] = useState("");
  const [company, setCompany] = useState("");
  const [address, setAddress] = useState("");
  const [notes, setNotes] = useState("");
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [imageEdit, setImageEdit] = useState(null);
  const [imageSourceProfile, setImageSourceProfile] = useState("");
  const [card, setCard] = useState(null);

  useEffect(() => {
    getAllCards(token, setCards);
  }, []);

  const handleOnChangeImage = (event) => {
    event.preventDefault();
    let file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.addEventListener("load", () => {
      const imageUrl = reader.result?.toString() || "";
      setImageEdit(imageUrl);
    });
    reader.readAsDataURL(file);
    document.getElementById("edit_photo_modal").showModal();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Perform your action here (e.g., submit form, send message)
      // Optional: prevent default form submission if wrapped in a <form>
      event.preventDefault();
      const val = event.target.value;
      setTags(() => [...tags, val]);
      setTagInput("");
    }
  };

  const handleChange = (event) => {
    setTagInput(event.target.value);
  };

  const handleOnClickAddPhone = (e) => {
    e.preventDefault();
    setAdditionalPhones(() => [
      ...additionalPhones,
      {
        phone: "",
        label: "personal",
      },
    ]);
  };

  const handleOnChangeAdditonalPhone = (e, ind) => {
    e.preventDefault();
    let add = additionalPhones;
    let data = add[ind];
    data.phone = e.target.value;
    add[ind] = data;
    setAdditionalPhones(() => [...add]);
  };

  const handleOnChangeAdditonalPhoneLabel = (e, ind) => {
    e.preventDefault();
    let add = additionalPhones;
    let data = add[ind];
    data.label = e.target.value;
    add[ind] = data;
    setAdditionalPhones(() => [...add]);
  };

  const handleOnClickAddEmail = (e) => {
    e.preventDefault();
    setAdditionalEmails(() => [
      ...additionalEmails,
      {
        email: "",
        label: "",
      },
    ]);
  };

  const handleOnChangeAdditonalEmail = (e, ind) => {
    e.preventDefault();
    let add = additionalEmails;
    let data = add[ind];
    data.email = e.target.value;
    add[ind] = data;
    setAdditionalEmails(() => [...add]);
  };

  const handleOnChangeAdditonalEmailLabel = (e, ind) => {
    e.preventDefault();
    let add = additionalEmails;
    let data = add[ind];
    data.label = e.target.value;
    add[ind] = data;
    setAdditionalEmails(() => [...add]);
  };

  const handleOnClickAddContact = async (e) => {
    e.preventDefault();
    setLoading(true);
    const cardSocial = generateCardSocial(
      additionalPhones,
      additionalEmails,
      address,
    );
    let dataJson = {
      company: company,
      connection_type: "MANUAL",
      contact_social: cardSocial,
      first_name: firstName,
      job_title: jobTitle,
      middle_name: null,
      last_name: lastName,
      notes: notes,
      tags: tags,
      user_card_id: card,
      user_connection_card_id: null,
    };
    let err = validateDataContact(dataJson);
    if (err != "") {
      toast.error(err, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
      return;
    }
    if (imageSourceProfile) {
      const profile_image_id = await uploadImage(
        token,
        imageSourceProfile,
        "contact",
      );
      dataJson.profile_image_id = profile_image_id;
    } else {
      dataJson.profile_image_id = "";
    }

    createContact(token, dataJson, setLoading, navigate);
  };

  useEffect(() => {
    if (indexCard != 0) {
      setCard(cards[indexCard - 1].card_id);
    } else {
      setCard(null);
    }
  }, [indexCard]);

  return (
    <div className="flex flex-col-reverse md:flex-row w-full bg-white h-fit md:h-full overflow-y-auto md:overflow-y-hidden">
      <ToastContainer />
      <div className="flex flex-col pb-40 md:pb-0 border-0 border-r-2 border-r-gray-200 w-full md:w-1/3 px-5 py-5 gap-3 md:overflow-y-hidden items-center justify-start">
        <ContactCard
          firstName={firstName}
          lastName={lastName}
          jobTitle={jobTitle}
          company={company}
          address={address}
          notes={notes}
          phones={additionalPhones}
          emails={additionalEmails}
          tags={tags}
          imageSourceProfile={imageSourceProfile}
        />
        <div
          className="px-10 py-2 bg-primary text-white shadow-lg hover:bg-tertiary active:translate-y-1 cursor-pointer rounded-lg"
          id="AddContact"
          onClick={handleOnClickAddContact}
        >
          {loading ? (
            <div role="status">
              <svg
                aria-hidden="true"
                className="w-6 h-6 text-gray-200 animate-spin fill-secondary"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="white"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="#E47410"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Add Contact"
          )}
        </div>
      </div>
      <div className="flex flex-col w-full md:w-2/3 p-5 md:h-[90vh]">
        <div className="flex flex-col gap-5 w-full pb-10 md:pb-20 overflow-y-auto">
          <div
            className="flex flex-row gap-2 px-4 py-2 rounded-lg bg-primary text-white cursor-pointer w-fit hover:bg-tertiary items-center"
            onClick={(e) => {
              e.preventDefault();
              setShowCapture(true);
            }}
          >
            <FaCamera />
            <div>Capture</div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col">
              <div className="font-bold">Personal Information</div>
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-col w-4/12">Profile Picture</div>
              <input
                type="file"
                accept="image/*"
                id="profile"
                ref={inputFile}
                className="hidden"
                onChange={(e) => handleOnChangeImage(e)}
              />
              <div className="flex flex-col w-6/12 gap-2">
                {imageSourceProfile ? (
                  <div className="flex flex-col">
                    <img
                      src={imageSourceProfile}
                      alt="header"
                      className="w-[200px]"
                    />
                  </div>
                ) : null}
                <div className="flex flex-row gap-4">
                  <div
                    onClick={(e) => {
                      inputFile.current.click();
                    }}
                    className="px-4 py-1 bg-primary text-[16px] font-regular cursor-pointer text-white w-fit rounded-lg hover:bg-tertiary"
                  >
                    {imageSourceProfile ? "Edit" : "Upload"}
                  </div>
                  {imageSourceProfile ? (
                    <div
                      onClick={(e) => setImageSourceProfile(null)}
                      className="px-4 py-1 bg-red-900 text-[16px] font-regular cursor-pointer text-white w-fit rounded-lg hover:bg-tertiary"
                    >
                      Delete
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-col w-4/12">First name*</div>
              <input
                className="flex flex-col border border-black rounded-lg w-6/12 h-[40px] px-3"
                type="text"
                name="firstName"
                value={firstName}
                onChange={(e) => {
                  e.preventDefault();
                  setFirstName(e.target.value);
                }}
              />
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-col w-4/12">Last name*</div>
              <input
                className="flex flex-col border border-black rounded-lg w-6/12 h-[40px] px-3"
                type="text"
                name="lastName"
                value={lastName}
                onChange={(e) => {
                  e.preventDefault();
                  setLastName(e.target.value);
                }}
              />
            </div>
            <div className="flex flex-row w-full items-start">
              <div className="flex flex-col w-4/12">Phone number*</div>
              <div className="flex flex-col w-8/12 gap-5">
                {additionalPhones.map((val, ind) => (
                  <>
                    <div className="flex flex-row w-full items-center">
                      <div className="flex flex-row border border-black rounded-lg w-3/4 h-[40px] px-3 justify-between items-center">
                        <input
                          className="flex flex-col focus:outline-none w-full"
                          type="text"
                          placeholder={`Phone ${ind + 1}: 081234567890`}
                          name={"phoneNumber" + ind}
                          value={val.phone}
                          onChange={(e) => handleOnChangeAdditonalPhone(e, ind)}
                        />
                        {ind != 0 && (
                          <div
                            className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
                            onClick={
                              additionalPhones.length > 1
                                ? () => {
                                    setAdditionalPhones(() =>
                                      additionalPhones.filter(
                                        (val, i) => i != ind,
                                      ),
                                    );
                                  }
                                : null
                            }
                          >
                            <img
                              src={trash_can}
                              alt="trash_can"
                              className="w-[20px]"
                            />
                          </div>
                        )}
                      </div>
                      {ind == 0 && (
                        <div
                          onClick={handleOnClickAddPhone}
                          className="flex flex-col h-full w-fit rounded-full active:bg-gray-100 p-2 justify-center items-center cursor-pointer hover:bg-gray-200 active:font-semibold"
                        >
                          <img
                            src={add_circle}
                            className="w-[25px] h-[25px]"
                          />{" "}
                        </div>
                      )}
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div className="flex flex-row w-full items-start">
              <div className="flex flex-col w-4/12">Email</div>
              <div className="flex flex-col w-8/12 gap-5">
                {additionalEmails.map((val, ind) => (
                  <>
                    <div className="flex flex-row w-full items-center">
                      <div className="flex flex-row border border-black rounded-lg w-3/4 h-[40px] px-3 justify-between items-center">
                        <input
                          className="flex flex-col focus:outline-none w-full"
                          type="text"
                          name={"email" + ind}
                          placeholder={`Email ${ind + 1}: example@gmail.com`}
                          value={val.email}
                          onChange={(e) => handleOnChangeAdditonalEmail(e, ind)}
                        />
                        {ind != 0 && (
                          <div
                            className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
                            onClick={
                              additionalEmails.length > 1
                                ? () => {
                                    setAdditionalEmails(() =>
                                      additionalEmails.filter(
                                        (val, i) => i != ind,
                                      ),
                                    );
                                  }
                                : null
                            }
                          >
                            <img
                              src={trash_can}
                              alt="trash_can"
                              className="w-[20px]"
                            />
                          </div>
                        )}
                      </div>
                      {ind == 0 && (
                        <div
                          onClick={handleOnClickAddEmail}
                          className="flex flex-col h-full w-fit rounded-full active:bg-gray-100 p-2 justify-center items-center cursor-pointer hover:bg-gray-200 active:font-semibold"
                        >
                          <img
                            src={add_circle}
                            className="w-[25px] h-[25px]"
                          />{" "}
                        </div>
                      )}
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-col w-4/12">Address</div>
              <input
                className="flex flex-col border border-black rounded-lg w-6/12 h-[40px] px-3"
                type="text"
                placeholder="12 St. Lower Park, 20390"
                name="address"
                value={address}
                onChange={(e) => {
                  e.preventDefault();
                  setAddress(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col">
              <div className="font-bold">Work Information</div>
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-col w-4/12">Job Title</div>
              <input
                className="flex flex-col border border-black rounded-lg w-6/12 h-[40px] px-3"
                type="text"
                placeholder="Regional manager"
                name="jobTitle"
                value={jobTitle}
                onChange={(e) => {
                  e.preventDefault();
                  setJobTitle(e.target.value);
                }}
              />
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-col w-4/12">Company</div>
              <input
                className="flex flex-col border border-black rounded-lg w-6/12 h-[40px] px-3"
                type="text"
                name="company"
                placeholder="Something Company"
                value={company}
                onChange={(e) => {
                  e.preventDefault();
                  setCompany(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col">
              <div className="font-bold">Others</div>
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-col w-4/12">Card</div>
              <select
                id="cards"
                className="bg-white border border-black text-gray-900 rounded-lg focus:outline-blue-500 focus:border-blue-500 block px-3 py-2 w-3/4 md:w-1/2"
                value={indexCard}
                onChange={(e) => setIndexCard(e.target.value)}
              >
                <option value={0}>No Card</option>
                {cards.map((val, ind) => (
                  <option key={ind} value={ind + 1}>
                    {val.card_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-col w-4/12">Tag</div>
              <div className="flex flex-col border border-black rounded-lg w-3/4 md:w-1/2 px-3 py-3 gap-2">
                <div className="flex flex-row flex-wrap gap-1">
                  {tags.map((val, ind) => (
                    <div
                      key={ind}
                      className="flex flex-row gap-2 px-2 py-1 rounded-lg bg-tertiary"
                    >
                      <span>{val}</span>
                      <span
                        className="cursor-pointer hover:font-semibold"
                        onClick={(e) => {
                          e.preventDefault();
                          setTags(() => tags.filter((val, i) => i != ind));
                        }}
                      >
                        x
                      </span>
                    </div>
                  ))}
                </div>
                <input
                  className="border-none focus:outline-none focus:ring-0 focus:border-none"
                  type="text"
                  placeholder="Add a tag..."
                  onChange={handleChange}
                  value={tagInput}
                  onKeyDown={handleKeyDown}
                />
              </div>
            </div>
            <div className="flex flex-row w-full items-center">
              <div className="flex flex-col w-4/12">Notes</div>
              <textarea
                className="flex flex-col resize-none border border-black rounded-lg w-3/4 md:w-1/2 px-3 py-3"
                value={notes}
                rows={5}
                placeholder="Give a notes like birthday, where do you meet, etc."
                onChange={(e) => {
                  e.preventDefault();
                  setNotes(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <ModalEditPhoto
        imgsrc={imageEdit}
        setImgSrc={setImageSourceProfile}
        aspect={1}
        circularCrop={true}
      />
      {showCapture && (
        <ModalCaptureContactData
          setShowCapture={setShowCapture}
          setFirstName={setFirstName}
          setLastName={setLastName}
          setJobTitle={setJobTitle}
          setCompany={setCompany}
          setShowCapture={setShowCapture}
        />
      )}
    </div>
  );
};

export default AddContact;
